export default __webpack_public_path__ + "static/media/user2.c2667c5a.svg";